import React from "react";
import { Link } from "react-router-dom";

export function Footer() {
  const footerLinks = [
    { name: "Privacy Policy", href: "/privacy", external: false },
    { name: "Terms of Use", href: "/terms", external: false },
    { name: "Disclaimer", href: "/disclaimer", external: false },
  ];

  return (
    <footer className="w-full border-t border-border bg-background/95 backdrop-blur-sm">
      <div className="mx-auto h-full w-full max-w-7xl px-6 py-4 md:py-6">
        <div className="border-b border-border pb-4">
          <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
            <p className="text-sm leading-none text-foreground">
              © 2025 Helm. All rights reserved.
            </p>

            <nav className="flex items-center gap-5 md:gap-8">
              {footerLinks.map((link) =>
                link.external ? (
                  <a
                    key={link.name}
                    href={link.href}
                    className="text-sm leading-none text-foreground transition-colors hover:text-primary"
                  >
                    {link.name}
                  </a>
                ) : (
                  <Link
                    key={link.name}
                    to={link.href}
                    className="text-sm leading-none text-foreground transition-colors hover:text-primary"
                  >
                    {link.name}
                  </Link>
                ),
              )}
              <a
                href="https://x.com/helmfinanceX"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-foreground transition-colors hover:text-primary"
                aria-label="Helm on X"
              >
                <svg
                  className="h-4 w-4"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>
            </nav>
          </div>
        </div>

        <div className="pt-3 text-xs leading-4 text-muted-foreground">
          <p>
            Helm is a decentralized, non-custodial protocol.
            <br />
            Trading involves significant risks, including potential loss of
            funds from market volatility, smart contract vulnerabilities, and
            liquidation events.
          </p>
          <p>
            The protocol does not provide financial, legal, or tax advice, and
            is not available in sanctioned jurisdictions.
          </p>
          <p>
            For more information, see our{" "}
            <Link to="/disclaimer" className="underline hover:text-foreground">
              Disclaimer
            </Link>{" "}
            and{" "}
            <Link to="/privacy" className="underline hover:text-foreground">
              Privacy Policy
            </Link>
            .
          </p>
        </div>
      </div>
    </footer>
  );
}
